import { batchScheduler } from 'batch-promise';
import quickFetch from 'quick-fetch';
import { createBatchedEarlyRequester } from '../../quickFetch/createBatchedEarlyRequester';
import { promisifyEarlyRequest } from '../../quickFetch/promisifyEarlyRequest';

type AppSettingCall = { appSettingName: string };

type BatchResponse = Record<string, Record<string, unknown>>;

const TYPE_METADATA_BATCH_URL =
  '/framework-builder/v1/read/metadata/type/all/batch';

export const extractAppSetting = ({
  response,
  input: { appSettingName },
}: {
  response: BatchResponse;
  input: AppSettingCall;
}) => {
  const result: Record<string, unknown> = {};

  for (const [fqn, settings] of Object.entries(response)) {
    const setting = settings[appSettingName];
    if (setting != null) {
      result[fqn] = setting;
    }
  }

  return result;
};

const scheduler = batchScheduler()
  .read<AppSettingCall>()
  .identity(({ appSettingName }) => appSettingName)
  .partition(() => 'appSettings')
  .execute<BatchResponse>((calls) => {
    const callsArray = Object.values(calls);
    return promisifyEarlyRequest<BatchResponse>({
      url: quickFetch.getApiUrl(TYPE_METADATA_BATCH_URL),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(callsArray.map((c) => c.appSettingName)),
      dataType: 'json',
    });
  })
  .extract(extractAppSetting)
  .immediate();

export const {
  request: earlyAppSettings,
  consume: consumeEarlyAppSettings,
  __TEST_ONLY_reset: __TEST_ONLY_abortAppSettingsEarlyScheduler,
} = createBatchedEarlyRequester('hs-resources:appSettings-early', scheduler);
